import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

import fullProduct from "../fragments/fullProduct"

const query = gql`
  query ProductsSearch($cursor: String, $limit: Int, $type: String, $supplier: String, $active: Boolean, $q: String, $currency: String) {
    productsSearch(cursor: $cursor, limit: $limit, type: $type, supplier: $supplier, active: $active, q: $q, currency: $currency) {
      results {
        ...fullProduct
      }
      total
      cursor
      limit
    }
  }
  ${fullProduct}
`

export default query

export const productsSearchKey = getQueryNames(query)[0]
